export default __webpack_public_path__ + "static/services-15dbc57ab228ffcf286bbb9e7b95082a.mp4";